<template>
  <md-dialog
    :md-active.sync="isOpen"
    @md-closed="onDialogClosed"
  >
    <md-dialog-title v-if="!transfer.hasTransferred">
      Transfer subscription <b>{{ subscription.account_subscription.name }}?</b>
    </md-dialog-title>
    <md-dialog-content v-if="!transfer.hasTransferred">
      <h4>Search new owner by</h4>

      <form @submit="fetchAccounts">
        <md-field>
          <label>Email</label>
          <md-input
            v-model="search.email"
          />
        </md-field>

        <span>or</span>

        <md-field>
          <label>User ID</label>
          <md-input
            v-model="search.id"
          />
        </md-field>
        
        <md-button type="submit">
          Search
        </md-button>
      </form>

      <hr>

      <md-progress-bar
        v-if="search.isLoading"
        md-mode="query"
      />
      <span
        v-else-if="search.error"
        class="error"
      >{{ search.error }}</span>
      <v-client-table
        v-else-if="accounts.length > 0"
        :data="accounts"
        :columns="['selected', 'email']"
      >
        <template #selected="{ row }">
          <md-radio
            v-model="transfer.selectedUserId"
            :value="row.id"
          />
        </template>

        <template #email="{ row }">
          <a
            :href="`/user/${row.id}`"
            target="_blank"
          >
            {{ row.email.email }}
          </a>
        </template>
      </v-client-table>
    </md-dialog-content>

    <md-dialog-content v-else>
      <h4>Subscription has been transferred to the new owner</h4>
      <a :href="`/user/${currentHolderUserId}`">Old owner page</a>
      <br>
      <a :href="`/user/${transfer.selectedUserId}`">New owner page</a>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button
        @click="onDialogClosed"
      >
        Cancel
      </md-button>
      <md-button
        v-if="!transfer.hasTransferred"
        class="md-primary"
        :disabled="!transfer.selectedUserId"
        @click="transferSubscription"
      >
        <md-progress-spinner
          v-if="transfer.isLoading"
          md-mode="indeterminate"
        />
        <span v-else>Transfer</span>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
export default {
  props: {
    isOpen: { type: Boolean, required: true },
    currentHolderUserId: { type: String, required: true },
    subscription: { type: Object, required: true },
  },
  data() {
    return {
      search: {
        email: "",
        id: "",
        isLoading: false,
        error: null,
      },
      accounts: [],
      transfer: {
        selectedUserId: null,
        isLoading: false,
        error: null,
        hasTransferred: false,
      },
    };
  },
  methods: {
    onDialogClosed() {
      this.$emit("update:isOpen", false);
    },
    fetchAccounts(e) {
      e.preventDefault();

      if (!this.search.email && !this.search.id) {
        this.search.error = "Input some filters, bro";
        return;
      }

      this.search.isLoading = true;
      this.search.error = null;
      this.accounts = [];
      this.transfer.selectedUserId = null;
      const params = new URLSearchParams();

      if (this.search.id) {
        params.set("filters.id", this.search.id);
      } else if (this.search.email) {
        params.set("filters.email", this.search.email);
      }

      this.$http.get(`/v1/admin/account/list-accounts?page_size=10&${params.toString()}`)
        .then(res => {
          this.accounts = res.data.accounts;
        }, err => {
          console.error(err);
          this.search.error = err;
        }).finally(() => {
          this.search.isLoading = false;
        });
    },
    transferSubscription() {
      this.transfer.isLoading = true;
      this.transfer.error = null;

      if (this.selectedUserId === this.currentHolderUserId) {
        this.transfer.error = "It's the same user, c'mon";
        this.transfer.isLoading = false;
        return;
      }

      this.$http.post("/v1/admin/store/subscription/change-owner", {
        subscription_id: this.subscription.account_subscription.subscription_id,
        new_account_id: this.transfer.selectedUserId,
      }).then(() => {
        this.transfer.hasTransferred = true;
      }, err => {
        console.error(err);
        this.transfer.error = err;
      }).finally(() => {
        this.transfer.isLoading = false;
      });
    },
  },
};
</script>
<style scoped>
  .error {
    color: red;
  }
</style>
